import { render, staticRenderFns } from "./VehicleSearch.vue?vue&type=template&id=2bc11aa3&"
import script from "./VehicleSearch.vue?vue&type=script&lang=js&"
export * from "./VehicleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports